import { SET_VWODS } from './constants';

export const setVwods = list => ({
  type: SET_VWODS,
  payload: list,
});
